import React from "react";
import {Modal} from "react-bootstrap";
import { Link } from 'react-router-dom'
import {Event} from "../../../../Helper";

export default class Terms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    componentDidMount() {
        Event.on('show_terms', () => {
            this.setState({ show: true, effect: 'pulse' });
        })
    }

    showPrivacy = (e) =>{
        e.preventDefault();
        this.setState({ show: true, effect: 'pulse' });
    };

    closePrivacy = () =>{
        this.setState({ show: false, effect: 'zoomOut'});
    };

    render() {
        return(
            <>
               <Link className="" to={'#'} onClick={this.showPrivacy}>
                    
                    <span className={'op-8'}>
                        Terms
                    </span>
                </Link>
                <Modal
                    size="lg"
                    centered={true}
                    backdrop={'static'}
                    show={this.state.show}
                    onHide={this.closePrivacy}
                    aria-labelledby="general-lg-modal"
                    className={"animated " + this.state.effect}
                >
                    <Modal.Header className={'font-light'}>
                       Terms
                        <button type="button" className="close p-2" onClick={this.closePrivacy}>
                            <i className={'mdi mdi-close'}/>
                        </button>
                    </Modal.Header>
                    <Modal.Body className={'modal-reader'}>
                        <p className={'text-white font-light mb-2 font-14'}>
                       
                       
                        </p>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}